const Tracking = {
  google: 'UA-11286850-3',
};

export default Tracking